/*
 * @Description: 应用授权失败重连逻辑
 * @Date: 2019-12-09 09:37:14
 */
// import axios from 'axios';
// import store from '../../store';
import send from '../app-message/send';
import store from '../../store';
import axios from 'axios';

let isCodeSync = false;
let CodeData = null;
let waitingCount = 0;

const waitingCountLimit = 50;
const retryLimit = 3;

// 清楚所有的状态，计数
const clearAllStatus = () => {
    waitingCount = 0;
    isCodeSync = false;
    CodeData = null;
}
// 接收消息带来的参数
const codeCallback = ({ params }) => {
    isCodeSync = true;
    CodeData = params;
}

/**
 * @Description: 等待消息返回，加上超时限制
 * 发消息是完全无状态的，这里的流程又需要阻塞，只能通过定时器模拟等待
 * @return: Promise
 */
const listenCallback = () => {
    return new Promise((resolve, reject) => {
        const timerEvent = () => {
            if (!isCodeSync && waitingCount < waitingCountLimit) {
                waitingCount++;
                setTimeout(() => { timerEvent() }, 100);
            } else {
                if (isCodeSync) {
                    resolve(CodeData);
                    clearAllStatus();
                } else {
                    reject('重连超时');
                }
            }
        }
        timerEvent();
    });
}

const reConnet = async function (res) {
    const config = res.config;
    const headers = res.headers;
    let retryCount = typeof config.headers['retry'] != 'undefined' ? config.headers['retry'] : retryLimit;
    if (retryCount > 0) {
        config.headers['retry'] = retryCount - 1;
    } else {
        return Promise.reject('重连次数超过限制');
    }
    // 发送请求
    send('generateCode');
    // 添加事件监听
    store.dispatch('addAppMessageCallBacks', {
        fn: codeCallback,
        eventType: 'syncCode'
    });
    let codeData = await listenCallback();
    // 写入code
    store.dispatch('setCode', codeData.code);
    // 重新登录获取apiToken
    await store.dispatch('login', {type : headers['x-app-type']});
    // 更换当前请求头中的apiToken

    return axios(config);
}

export default reConnet;